import { ConfigureReturnShipment } from '../components/configure-return-shipment';
import { ShippingOptions } from '../components/shipping-options';

export function ShipmentConfigurator() {
  return (
    <>
      <ConfigureReturnShipment />
      <ShippingOptions />
    </>
  );
}
